import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import {InstanceAPIs, Instances} from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import {
    makeSelectInProgress,
    makeSelectObjectsArray, removeObjects, requestObjects, updateObjects
} from '../../../../store/Objects';

import {requestObject, makeSelectObject, makeSelectInProgress as makeSelectObjectInProgress, removeObject} from "../../../../store/Object";

import AddEditDomainModal , { MapDispatchToPropsType, MapStateToPropsType } from '../organisms/AddEditDomainModal';

const mapStateToProps = (state: IStateType) => {
    const params = getParams(state);
    const selectCredentialGroups = makeSelectObjectsArray(Instances.UserGroup);
    const selectInProgress = makeSelectInProgress(Instances.UserGroup);
    const selectSipDomainLocation = makeSelectObject(Instances.SipDomainLocation);
    const selectDomainLocationInProgress = makeSelectObjectInProgress(Instances.SipDomainLocation);
    return {
        params,
        credentialGroupList: selectCredentialGroups(state),
        inProgress: selectInProgress(state),
        sipDomainLocation: selectSipDomainLocation(state),
        sipDomainLocationInProgress: selectDomainLocationInProgress(state),
    };
};

const mapDispatchToProps = {
    closeModal: () => closeSideBar([removeObjects(Instances.UserGroup),removeObject(Instances.SipDomainLocation),removeObject(Instances.SipDomain)]),
    loadCredentialGroups: () => requestObjects(Instances.UserGroup, {}),
    getSipDomainLocations: (cb:(res:any,success:boolean) => void) => requestObject(Instances.SipDomainLocation, {},{},undefined,true,true,undefined,cb),
    checkDomainAvailability: (domain:string, cb?:(res:any,success:boolean)=>void )=> requestObject(Instances.SipDomain, {},{},'get',true,true,undefined,cb,domain),
    onCreateDomain: (reqData: any, keyForIdentifier:string,  cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.SipDomain, "POST", reqData, undefined, undefined, keyForIdentifier, undefined, undefined, cb, '', InstanceAPIs[Instances.SipDomain].POST),
    onEditDomain: (reqData: any,dynamicUrlData:string, keyForIdentifier:string, cb?: (res: any, success: boolean) => void) =>  updateObjects(Instances.SipDomain, "PUT", reqData, undefined, undefined, keyForIdentifier, undefined, undefined, cb, dynamicUrlData, InstanceAPIs[Instances.SipDomain].PUT),
};

export default connect<MapStateToPropsType, MapDispatchToPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(AddEditDomainModal));
